// LiveToast intentionally skips auto-dismissal for Phoenix flash messages
// (see deps/live_toast/assets/js/live_toast/live_toast.ts isFlash early-return).
// We auto-dismiss :info flashes only — :error stays sticky so users can read
// and acknowledge failures.

const INFO_FLASH_AUTO_DISMISS_MS = 6000

export function withInfoFlashAutoDismiss(baseHook) {
  const originalMounted = baseHook.mounted
  const originalUpdated = baseHook.updated
  const originalDestroyed = baseHook.destroyed

  function scheduleInfoFlashAutoDismiss() {
    if (this.el.id !== "flash-info") {
      return
    }

    if (this.__infoFlashTimer) {
      window.clearTimeout(this.__infoFlashTimer)
    }

    this.__infoFlashTimer = window.setTimeout(() => {
      // Dispatching flash-leave triggers LiveToast's existing slide-out animation,
      // then we tell the server to clear the flash assign so it doesn't re-render.
      this.el.dispatchEvent(new CustomEvent("flash-leave", { bubbles: true }))
      this.pushEvent("lv:clear-flash", { key: "info" })
    }, INFO_FLASH_AUTO_DISMISS_MS)
  }

  return {
    ...baseHook,

    mounted() {
      originalMounted?.call(this)
      scheduleInfoFlashAutoDismiss.call(this)
    },

    updated() {
      originalUpdated?.call(this)
      scheduleInfoFlashAutoDismiss.call(this)
    },

    destroyed() {
      if (this.__infoFlashTimer) {
        window.clearTimeout(this.__infoFlashTimer)
        this.__infoFlashTimer = null
      }

      originalDestroyed?.call(this)
    },
  }
}
